/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  root: 'root_4b679915',
  item: 'item_4b679915',
};

export = styles;

loadStyles([{"rawString":".root_4b679915{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.item_4b679915{-ms-flex-negative:0;flex-shrink:0}"}]);
/* tslint:enable */